/**
 * @generated SignedSource<<cff6572be13e5d55affac55ea7a0d8b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionClosed_item$data = {
  readonly isUnavailable: boolean | null;
  readonly relevantAuctionSolution: {
    readonly reserveMet: boolean | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_item" | "useAuctionSecondChanceInfo_item" | "useAuctionState_item">;
  readonly " $fragmentType": "PdpSharedAuctionClosed_item";
};
export type PdpSharedAuctionClosed_item$key = {
  readonly " $data"?: PdpSharedAuctionClosed_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionClosed_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionClosed_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reserveMet",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionSolution(page:\"pdp\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnavailable",
      "storageKey": null
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionSecondChanceInfo_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "4a163fcd329ff8b91f555c5600f69cce";

export default node;
